import { adjustLightness, colorContrast } from 'src/utils/Color'

const light = '#fff'
const dark = '#333'

const setBrandColor = color => {
  if (!/^#([0-9a-f]{3}){1,2}$/i.test(color)) return

  const style = document.getElementById('branding-css') || (() => {
    const style = document.createElement('style')
    style.setAttribute('data-color', color)
    document.head.appendChild(style)
    return style
  })

  const curColor = style.getAttribute('data-color')
  style.setAttribute('data-color', color)
  if (!curColor || curColor == color) return

  const contrastColor = colorContrast(color, light, dark, 28)

  style.textContent = `
    a, .text-primary { color: ${color}; }
    a:hover, a:focus { color: ${adjustLightness(color, -0.15)}; }
    .bg-primary {
      background: ${color};
      color: ${contrastColor};
    }
    .widget-link, .widget-link:hover, .widget-link:focus {
      color: ${contrastColor};
    }
  `
}

export default setBrandColor
